import React, { useContext, useState, useEffect } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import ListIcon from "@material-ui/icons/List";
import { StoreContext } from "../../../store/Provider";
import ModalContainer from "../../common/ModalBox/ModalContainer";
import ShipmentInfo from "./shipmentBody/ShipmentInfo/ShipmentInfo";
import "./shipment.css";
import MenuItem from "@material-ui/core/MenuItem";
import AllShipments from "./shipmentBody/AllShipments";
import TransitShipm from "./shipmentBody/TransitShipm";
import ArrivedShipm from "./shipmentBody/ArrivedShipm";
import { withStyles } from "@material-ui/core/styles";
import { getUserData } from "../../common/utility/Utils";
import ShipmentSearchResults from "./shipmentBody/ShipmentSearchResults";
import Menu from "@material-ui/core/Menu";
import axios from "axios";
import { basename, HOST_URL, LOCAL_STORAGE_KEY } from "../../../config";
import moment from "moment";
// import LayoutWithLogin from '../../common/Layout/LayoutWithLogin';
import MainLayout from "../../common/Layout/MainLayout";
import { IsShowShipmentList } from "../../../utils";

const Shipments = () => {
  const [value, setValue] = React.useState(0);
  const context = useContext(StoreContext);
  const [loadingMore, setLoadingMore] = useState(true);
  let d = new Date();
 console.log('Mass Data1111', context.massData, context.co2ShipmentID)
  const [allShipments, setAllShipments] = useState({
    data: [],
    loading: false,
    loadMore: false,
    hasMore: false,
    pageNumber: 1,
    ImageData: "",
  });

  const [transitShipm, setTransitShipm] = useState({
    data: [],
    loading: false,
    loadMore: false,
    hasMore: false,
    pageNumber: 1,
    ImageData: "",
  });

  const [arrivedShipm, setArrivedShipm] = useState({
    data: [],
    loading: false,
    loadMore: false,
    hasMore: false,
    pageNumber: 1,
    ImageData: "",
  });
console.log("dataaa",allShipments);
useEffect(() => {
  if (context.co2ShipmentID && context.massData.amount && context.massData.unit) {
    setAllShipments(prevState => {
      const index = prevState.data.findIndex(
        shipment => shipment.ShipmentId === context.co2ShipmentID
      );
      
      if (index !== -1) {
        const updatedData = [...prevState.data];
        updatedData[index] = {
          ...updatedData[index],
          amount: context.massData.amount,
          unit: context.massData.unit
        };
        
        return {
          ...prevState,
          data: updatedData
        };
      }

      return prevState; // No changes needed if index is -1
    });
  }
}, [context.massData.amount, context.massData.unit]);


useEffect(() => {
  if (context.co2ShipmentID && context.massData.amount && context.massData.unit) {
    setTransitShipm(prevState => {
      const index = prevState.data.findIndex(
        shipment => shipment.ShipmentId === context.co2ShipmentID
      );
      
      if (index !== -1) {
        const updatedData = [...prevState.data];
        updatedData[index] = {
          ...updatedData[index],
          amount: context.massData.amount,
          unit: context.massData.unit
        };
        
        return {
          ...prevState,
          data: updatedData
        };
      }

      return prevState; // No changes needed if index is -1
    });
  }
}, [context.massData.amount, context.massData.unit]);

useEffect(() => {
  if (context.co2ShipmentID && context.massData.amount && context.massData.unit) {
    setArrivedShipm(prevState => {
      const index = prevState.data.findIndex(
        shipment => shipment.ShipmentId === context.co2ShipmentID
      );
      
      if (index !== -1) {
        const updatedData = [...prevState.data];
        updatedData[index] = {
          ...updatedData[index],
          amount: context.massData.amount,
          unit: context.massData.unit
        };
        
        return {
          ...prevState,
          data: updatedData
        };
      }

      return prevState; // No changes needed if index is -1
    });
  }
}, [context.massData.amount, context.massData.unit]);

  

  useEffect(() => {
    getShipmentsList(1, "All");
    getShipmentsList(1, "Loaded");
    getShipmentsList(1, "Close");
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    context.setShipmentId("");
  };

  const getShipmentsList = async (pageNumber, cargoStatus) => {
    let data = {};
    if (pageNumber === 1 && cargoStatus === "All") {
      setAllShipments({
        ...allShipments,
        data: [],
        loading: true,
        pageNumber: pageNumber,
      });
    } else if (pageNumber === 1 && cargoStatus === "Loaded") {
      setTransitShipm({
        ...transitShipm,
        data: [],
        loading: true,
        pageNumber: pageNumber,
      });
    } else if (pageNumber === 1 && cargoStatus === "Close") {
      setArrivedShipm({
        ...arrivedShipm,
        data: [],
        loading: true,
        pageNumber: pageNumber,
      });
    }
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        console.log(res);
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });

    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };

    console.log({ header });
    const END_POINT = `${HOST_URL}api/v2/ShipmentData/${data.user_country_code}/Get/${data.user_company_code}?page.cargoStatus=${cargoStatus}&page.pageNumber=${pageNumber}&page.pageSize=20`;
    axios
      .get(END_POINT, {
        headers: header,
      })
      .then((res) => {
        setLoadingMore(true);
        // console.log(res.data);
        if (cargoStatus === "All") {
          getAllData(res.data, pageNumber);
        } else if (cargoStatus === "Loaded") {
          getTransitData(res.data, pageNumber);
        } else {
          getArrivedData(res.data, pageNumber);
        }
      })
      .catch((err) => {
        console.error(err);
        if (cargoStatus === "All") {
          setAllShipments({
            ...allShipments,
            data: [],
            loading: false,
            hasMore: false,
          });
        } else if (cargoStatus === "Loaded") {
          setTransitShipm({
            ...transitShipm,
            data: [],
            loading: false,
            hasMore: false,
          });
        } else {
          setArrivedShipm({
            ...arrivedShipm,
            data: [],
            loading: false,
            hasMore: false,
          });
        }
      });
  };

  const getAllData = (data, pageNumber) => {
    let hasMore = data.Data.length === 20 ? true : false;
    if (pageNumber === 1) {
      setAllShipments({
        ...allShipments,
        data: data.Data,
        loading: false,
        hasMore: hasMore,
        pageNumber: pageNumber,
        ImageData: data.ImageData,
      });
    } else {
      setAllShipments({
        ...allShipments,
        data: [...allShipments.data, ...data.Data],
        hasMore: hasMore,
        pageNumber: pageNumber,
      });
    }
  };

  const getTransitData = (data, pageNumber) => {
    let hasMore = data.Data.length === 20 ? true : false;
    if (pageNumber === 1) {
      setTransitShipm({
        ...transitShipm,
        data: data.Data,
        loading: false,
        hasMore: hasMore,
        ImageData: data.ImageData,
      });
    } else {
      setTransitShipm({
        ...transitShipm,
        data: [...transitShipm.data, ...data.Data],
        hasMore: hasMore,
        pageNumber: pageNumber,
      });
    }
  };

  const getArrivedData = (data, pageNumber) => {
    let hasMore = data.Data.length === 20 ? true : false;
    if (pageNumber === 1) {
      setArrivedShipm({
        ...arrivedShipm,
        data: data.Data,
        loading: false,
        hasMore: hasMore,
        ImageData: data.ImageData,
      });
    } else {
      setArrivedShipm({
        ...arrivedShipm,
        data: [...arrivedShipm.data, ...data.Data],
        hasMore: hasMore,
        pageNumber: pageNumber,
      });
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onAllLoadMore = () => {
    let count = allShipments.pageNumber + 1;
    if (loadingMore) {
      getShipmentsList(count, "All");
      setLoadingMore(false);
    }
  };

  const onSortBy = (element) => {
    context.setSearchResultView(true);
    context.setShipmentId("");
    context.setAdvFilterCall(false);
    context.setAdvSearchFilter({
      tranportMode: "",
      etd: element.eta,
      eta: "",
    });
    setAnchorEl(null);
  };

  const onReset = () => {
    context.setSearchResultView(false);
    context.setShipmentId("");
    context.setSearchInputValue("");
  };

  const onTransitLoadMore = () => {
    let count = transitShipm.pageNumber + 1;
    if (loadingMore) {
      getShipmentsList(count, "Loaded");
      setLoadingMore(false);
    }
  };

  const onArrivedLoadMore = () => {
    let count = arrivedShipm.pageNumber + 1;
    if (loadingMore) {
      getShipmentsList(count, "Close");
      setLoadingMore(false);
    }
  };

  const resetHeaderSearchValue = () => {
    context.setShipmentId("");
    context.setSearchInputValue("");
    context.setSearchResultView(false);
  };

  const directions = [
    {
      id: 1,
      text: "Current Day",
      eta: moment(d).format("MM/DD/YYYY"),
      //etd : "",
    },
    {
      id: 2,
      text: "Last 3 Days",
      eta: `${moment().subtract(3, "days").format("MM/DD/YYYY")} - ${moment(
        d
      ).format("MM/DD/YYYY")}`,
      //etd : moment().subtract(3, 'days').format("MM/DD/YYYY"),
    },
    {
      id: 3,
      text: "Last 7 Days",
      eta: `${moment().subtract(7, "days").format("MM/DD/YYYY")} - ${moment(
        d
      ).format("MM/DD/YYYY")}`,
      //etd : moment().subtract(7, 'days').format("MM/DD/YYYY"),
    },
    {
      id: 4,
      text: "Last 15 Days",
      eta: `${moment().subtract(15, "days").format("MM/DD/YYYY")} - ${moment(
        d
      ).format("MM/DD/YYYY")}`,
      //etd : moment().subtract(15, 'days').format("MM/DD/YYYY"),
    },
  ];

  const { ShipmentPermisionCollection } = JSON.parse(
    localStorage.getItem("newTempData")
  );

  console.log(ShipmentPermisionCollection);

  const shipmentsExcel = () => {
    let excelData = "";
    if (value === 0) {
      excelData = allShipments.ImageData;
    } else if (value === 1) {
      excelData = transitShipm.ImageData;
    } else if (value === 2) {
      excelData = arrivedShipm.ImageData;
    }
    const linkSource = `data:application/vnd.ms-excel;base64,${excelData}`;
    const downloadLink = document.createElement("a");
    const fileName = `Shipment_Report.xlsx`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  return (
    <div className="shipmentscomp">
      <ModalContainer type="filterModal" />
      {IsShowShipmentList() ? (
        <div className="shipmentheader">
          <div className="shipmentheadertabsparent">
            {context.searchResultView ? (
              <div className="matchedSearchResultsHeading">
                <span className="matchedResultspan">Matched Results</span>
                <Button onClick={resetHeaderSearchValue}>
                  <img
                    src={`/${basename}/Assets/Images/close.svg`}
                    alt="search"
                  />
                </Button>
              </div>
            ) : (
              <Tabs
                value={value}
                onChange={handleChange}
                className="shipmentTabParent"
              >
                <Tab
                  label="All Shipments"
                  {...a11yProps(0)}
                  className="shipmentTab"
                />
                <Tab
                  label="Transit Shipments"
                  {...a11yProps(1)}
                  className="shipmentTab"
                />
                <Tab
                  label="Arrived Shipments"
                  {...a11yProps(2)}
                  className="shipmentTab"
                />
              </Tabs>
            )}
          </div>
          <div className="shipmentheaderbuttongroups">
            <Button
              variant="contained"
              className="shipmentheaderbutton"
              onClick={shipmentsExcel}
            >
              Shipments Report <i className="fas fa-file-excel"></i>
            </Button>
            <Button
              variant="contained"
              className="shipmentheaderbutton"
              onClick={handleClick}
            >
              Sort By <ListIcon />
            </Button>
            <StyledMenu
              id="mailMenu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {directions.map((element) => {
                return (
                  <MenuItem onClick={() => onSortBy(element)} key={element.id}>
                    {element.text}
                  </MenuItem>
                );
              })}
              {/* <MenuItem onClick={handleClose}>Last 3 Days</MenuItem>
                        <MenuItem onClick={handleClose}>Last 7 Days</MenuItem>
                        <MenuItem onClick={handleClose}>Last 15 Days</MenuItem> */}
            </StyledMenu>
            <Button
              variant="contained"
              className="shipmentheaderbutton"
              onClick={() => {
                context.setModalType("filterModal");
                context.handleModalOpen();
              }}
            >
              Filters
              <i className="fas fa-filter"></i>
            </Button>
            <Button
              variant="contained"
              className="shipmentheaderbutton selected"
              onClick={() => onReset()}
            >
              Reset
            </Button>
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className={
          IsShowShipmentList() ? "shipmentatbsbody" : "shipmentatbsbody_new"
        }
      >
        <div
          className={
            IsShowShipmentList()
              ? "shipmentsCardsColParent"
              : "shipmentsCardsColParent_new"
          }
        >
          {context.searchResultView ? (
            <div className="tabshipment">
              <ShipmentSearchResults onLoadMore={onArrivedLoadMore} />
            </div>
          ) : IsShowShipmentList() ? (
            <>
              <TabPanel value={value} className="tabshipment" index={0}>
                <AllShipments
                  shipmentList={allShipments}
                  onLoadMore={onAllLoadMore}
                />
              </TabPanel>
              <TabPanel value={value} className="tabshipment" index={1}>
                <TransitShipm
                  shipmentList={transitShipm}
                  onLoadMore={onTransitLoadMore}
                />
              </TabPanel>
              <TabPanel value={value} className="tabshipment" index={2}>
                <ArrivedShipm
                  shipmentList={arrivedShipm}
                  onLoadMore={onArrivedLoadMore}
                />
              </TabPanel>
            </>
          ) : (
            ""
          )}
        </div>
        <div
          className={
            IsShowShipmentList()
              ? "shipmentdetailsParent"
              : "shipmentdetailsParent_new"
          }
        >
          <ShipmentInfo />
        </div>
      </div>
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div hidden={value !== index} id={`simple-tabpanel-${index}`} {...other}>
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

export default Shipments;
